module.exports = __webpack_public_path__ + "static/media/Siemens_Sans_Roman.8a11eeb0.ttf";